export class Feature {
  constructor(public readonly name: string) {}
}
